import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';

import { ThemeService } from 'ngx-elvis-ds';
import { BaseComponent, Helpers } from 'ngx-elvis-ds';
import { ConfigService } from 'src/app/config.service';
import { HttpClient } from '@angular/common/http';
import { ImageHelpers } from 'src/app/base/image-helpers';
import { I18NService } from 'src/app/services/i18n.service';

@Component({
  selector: 'elv-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss']
})
export class ProductItemComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  //@ViewChild('button', { static: true }) button: ElementRef;
  @Input() color: string = 'dark';
  @Input() height: Number;

  @Input() image: string;
  @Input() label: string;
  @Input() price: number;
  @Input() code: string;
  @Input() disabled: boolean;
  @Input() config: ConfigService;
  @Input() qty: number;

  followUpItem: boolean = false;

  constructor(
    private themes: ThemeService,
    public i18nSvc: I18NService,
    public configSvc: ConfigService
  ) {
    super();
  }

  ngOnChanges() {
    this.styleInit();
  }

  ngOnInit() {
    this.styleInit();
    this.subscriptions.themeEvents = this.themes.events.subscribe(() => { this.styleInit(); });
  }

  ngOnDestroy() {
    if (this.subscriptions.themeEvents) {
      this.subscriptions.themeEvents.unsubscribe();
    }
  }

  imgError(ev: any) {
    this.image = null;
  }

  // private

  private styleInit() {
    if (this.image && this.image.substr(0, 4) === 'http') {
      return;
    }
    if (this.code && this.config) {
      this.image = ImageHelpers.getImageURL('velocity-code-images', this.image, this.config)
    } else {
      this.image = null;
    }
  }
}
